import React from 'react';
import clone from 'clone';


const { findIndex } = _;
const $ = jQuery;
const RE = REBUILDER;

class IsotopBar extends React.Component {
  constructor(props) {
    super(props);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.state = {
      'options': [],
      selected: '*',
    };
  }
  componentDidMount() {
    this.initIsotope();
  }
  initIsotope() {
    setTimeout(() =>
    IsotopeGrid = $('.rq-isotope-grid').isotope({
      itemSelector: '.rq-element-item',
      layoutMode: 'masonry',
      percentage: true,
    })
    , 0);
  }

  handleFilterButton(item, e) {
    e.preventDefault();
    const filterValue = e.currentTarget.dataset.filter;
    IsotopeGrid.isotope({ filter: filterValue });
    if (item.slug !== undefined) {
      this.setState({ selected: item.slug });
    } else {
      this.setState({ selected: item });
    }
  }
  isChecked(value) {
    return 'rq-filter-link ' + ((value === this.state.selected) ? 'is-checked' : '');
  }
  capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }
  render() {
    this.helperData = RE.hasOwnProperty(this.metakey) ? clone(RE[this.metakey].helperData) : {};
    if (this.props.block.selectedDataType !== null) {
      // taxonomies
      if (this.props.block.selectedDataType === 'taxonomies' && this.helperData) {
        this.options = this.helperData.terms[this.props.block.selectedTaxonomy] ? this.helperData.terms[this.props.block.selectedTaxonomy].linear : [];
      }
    }
    const showCatagory = (item, index) => {
      return (
        <a type="text" key={'showcategory-' + index} className={this.isChecked(item.slug)} data-filter={'.' + item.slug} onClick={this.handleFilterButton.bind(this, item)}>
          {this.capitalize(item.value.trim())}
        </a>
      );
    };
    return (<div>
      <div>
        {this.options !== undefined && this.options.length ? <div id="filters" className="rq-isotope-filters-content">
                  <a type="text" className={this.isChecked('*')} data-filter="*" onClick={this.handleFilterButton.bind(this, '*')}>Show all</a>
                  {this.options.map(showCatagory)}
                </div> : null }
      </div>
      {this.options !== undefined && this.options.length === 0 && this.state.toogle ?
        <div className={'rq-no-attributes-found'}>
          <h3>{API.LANG.NO_ATTR_FOUND}</h3>
        </div> : ''}
    </div>);
  }
  }
IsotopBar.propTypes = {
  'previewData': React.PropTypes.object,
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
  'selectedDataType': React.PropTypes.string,
  'selectedTaxonomy': React.PropTypes.string,
};
export default IsotopBar;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/bar/isotopeBar.js
 **/